import styled, { css } from 'styled-components';

// Container principal do layout
export const BuiCompare = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${({ bgColor, theme }) => bgColor || theme.colors.background.primary};
  inset: 0;
`;

// Controladores
export const Controllers = styled.div`
  justify-content: center;
  align-items: center;
  gap: 6px;
  z-index: 1;
  position: absolute;
  bottom: 20%;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  width: 100%;
  display: flex;
  padding: 0 8px;
  flex-wrap: wrap;

  &.dragging {
    pointer-events: none;
  }

  button {
    background-color: ${({ theme }) => theme.colors.element.disabled};
    border-radius: 50%;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;

    &:disabled {
      cursor: not-allowed;

      svg {
        opacity: 0.3;
      }
    }

    svg {
      color: ${({ theme }) => theme.colors.element.primary};
      width: 24px;
      height: 24px;

      &.invert {
        transform: rotateY(160deg);
      }
    }

    @media (max-width: 675px) {
      width: 24px;
      height: 24px;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

// Controle da imagem
export const ImageControl = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  position: relative;
  gap: 1px;
  flex: 1 1 300px;
  justify-content: center;
  //border-bottom: 1px solid ${({ theme }) => theme.colors.divider.primary};

  &:hover {
    ${Controllers}:not(.dragging) {
      opacity: 1;
    }
  }

  .divider {
    width: 1px;
    height: calc(100% - 48px);
    background-color: ${({ theme }) => theme.colors.divider.primary};
    opacity: 0.8;
    position: absolute;
    right: 0;
    top: 24px;
  }

  &:last-of-type {
    .divider {
      display: none;
    }
  }

  @media (max-width: 1202px) {
    height: 50%;
  }

  @media (max-width: 600px) {
    flex: 1 1 200px;
  }

  @media (max-width: 400px) {
    flex: 1 1 150px;
  }

  @media (max-width: 300px) {
    flex: 1 1 100px;
  }

  ${({ count }) =>
    count === 3 &&
    css`
      @media (max-width: 1202px) {
        height: 100%;
      }

      @media (max-width: 901px) {
        height: 50%;
      }
    `}

  ${({ count }) =>
    count === 2 &&
    css`
      flex: 1 1 350px;

      @media (max-width: 1202px) {
        height: 100%;
      }

      @media (max-width: 700px) {
        height: 50%;
      }

      @media (max-width: 600px) {
        flex: 1 1 350px;
      }
    `}
  
  ${({ count }) =>
    count === 1 &&
    css`
      @media (max-width: 1202px) {
        height: 100%;
      }
    `}
`;

export const CompareContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  gap: 1px;
  flex-wrap: wrap;
`;

// Container da imagem
export const ImageContainer = styled.div`
  height: 100%;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;

  img,
  .pdf-container {
    border-radius: 8px;
    user-select: none;
    width: 100%;
  }
`;
